export default __webpack_public_path__ + "static/media/runningshot.78ea1481.png";